import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/listings/home";
import Listings from "./pages/listings/listingPage";
import GeneralVeterinaryPage from "./pages/categories/generalVeterinaryCare";
import AdminLayout from "./admin/layouts/AdminLayout";
import Dashboard from "./admin/pages/Dashboard";
import Users from "./admin/pages/Users";
import NotFound from "./pages/NotFound";
import { ToastProvider } from "./admin/components/Toast"; // Import ToastProvider
import Posts from "./admin/pages/Posts";
import Categories from "./admin/pages/Categories";
import Contact from "./admin/pages/Contact";
import Settings from "./admin/pages/Settings";
import Images from "./admin/pages/Images";
import CategoryPostsPage from "./pages/posts/listings";
import PostDetailPage from "./pages/posts/postDetail";
import LoginPage from "./pages/users/login";
import SignupPage from "./pages/users/signup";
import AccountPage from "./pages/users/account";
import MyPostsPage from "./pages/users/my-posts";
import Navbar from "./components/common/Navbar";
import VerifyEmailPage from "./pages/users/verify-email";
import CategorySelect from "./pages/posts/categorySelect";
import CreatePost from "./pages/posts/createPost";
import EditPost from "./pages/posts/editPost";
import ManageListingPage from "./pages/listings/manageListingPage";
import PaymentPage from "./pages/payment/PaymentPage";
import PaymentSuccessPage from "./pages/payment/PaymentSuccessPage";
import GuestPaymentPage from "./pages/payment/GuestPaymentPage";
import StripeErrorPage from "./pages/payment/StripeErrorPage";
import StatusPage from "./pages/StatusPage";
import ForgotPasswordPage from "./pages/users/ForgotPassword";
import ResetPasswordPage from "./pages/users/ResetPassword";
import SearchPage from "./pages/posts/searchpage";

function App() {
  return (
    <ToastProvider>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/listings/:slug/all" element={<Listings />} />
          <Route path="/listing/:slug" element={<GeneralVeterinaryPage />} />
          <Route path="/post" element={<CategorySelect />} />
          <Route path="/post/:category_id" element={<CreatePost />} />
          <Route path="/listing" element={<CategoryPostsPage />} />
          <Route path="/listings/:postid" element={<PostDetailPage />} />
          <Route path="/my-posts" element={<MyPostsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/edit-post/:id" element={<EditPost />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/stripe-error" element={<StripeErrorPage />} />
          <Route path="/status" element={<StatusPage />} />
          <Route
            path="/manage-listing/:management_token"
            element={<ManageListingPage />}
          />
          <Route path="/payment/:listingId" element={<PaymentPage />} />
          <Route
            path="/payment-success/:listingId"
            element={<PaymentSuccessPage />}
          />
          <Route
            path="/guest-payment/:managementToken"
            element={<GuestPaymentPage />}
          />
          <Route
            path="/guest-payment-success/:managementToken"
            element={<PaymentSuccessPage />}
          />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="posts" element={<Posts />} />
            <Route path="categories" element={<Categories />} />
            <Route path="images" element={<Images />} />
            <Route path="contact" element={<Contact />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;
